import React from 'react';
import {
  Container,
  Box,
  Paper,
  Typography,
  Divider,
  Card,
  CardContent,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.jsx';
import { useLanguage } from '../contexts/LanguageContext.jsx';
import GoogleLoginButton from '../components/GoogleLoginButton.jsx';

const LoginPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const { t } = useLanguage();

  // Redirect if already authenticated
  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>

      <Card elevation={3} sx={{ borderRadius: 3 }}>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <Typography variant="h5" component="h2" sx={{ fontWeight: 'medium', mb: 1, color: 'primary.main' }}>
              Welcome to <Box component="span" sx={{ fontWeight: 'bold' }}>Nexfah</Box> <Box component="span" sx={{ fontWeight: 'normal' }}>motoring</Box>
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Quick and easy MOT booking service
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 3 }}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2, textAlign: 'center' }}>
              Sign in with your Google account to continue
            </Typography>
            <GoogleLoginButton />
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              By signing in, you agree to our Terms of Service and Privacy Policy
            </Typography>
          </Box>
        </CardContent>
      </Card>

      <Box sx={{ textAlign: 'center', mt: 4 }}>
        <Typography variant="body2" color="text.secondary">
          Don't have a Google account?{' '}
          <a href="https://accounts.google.com/signup" target="_blank" rel="noopener noreferrer">
            Create one here
          </a>
        </Typography>
      </Box>
    </Container>
  );
};

export default LoginPage;